import { useState, useEffect, useRef } from "react";
import { getVideoFromIndexedDB, saveVideoToIndexedDB } from "./db";

export const VideoPlayer = ({ button }) => {
    const vids = button.content; // Array di video
    const [currIdx, setCurrIdx] = useState(0); // Stato per l'indice del video corrente
    const [localUrls, setLocalUrls] = useState({}); // { url: objectUrl }
    const videoRef = useRef(null);

    // Scarica e salva tutti i video in locale se non presenti
    useEffect(() => {
        vids.forEach(async (vid) => {
            const videoPath = vid.url;
            if (!videoPath) return;
            if (localUrls[videoPath]) return;

            let blob = await getVideoFromIndexedDB(videoPath);
            if (!blob) {
                const response = await fetch(`https://api.psicopatici.com/public/${videoPath}`);
                blob = await response.blob();
                await saveVideoToIndexedDB(videoPath, blob);
            }
            const objectUrl = URL.createObjectURL(blob);
            setLocalUrls(prev => ({ ...prev, [videoPath]: objectUrl }));
        });
        // eslint-disable-next-line
    }, [vids]);

    if (!vids[currIdx]) return null; // Se il video corrente non esiste, non renderizzare nulla

    const { url } = vids[currIdx]; // Ottieni l'URL del video corrente

    const onVideoEnd = () => {
        setCurrIdx((prev) => (prev + 1) % vids.length);
    };

    const handleVideoError = () => {
        const video = videoRef.current;
        if (video) {
            console.warn("Video error, attempting reload...");
            video.load();
            video.play().catch(() => {});
        }
    };

    const handleVideoStalled = () => {
        const video = videoRef.current;
        if (video && video.paused) {
            console.warn("Video stalled, attempting to resume...");
            video.play().catch(() => {});
        }
    };

    return (
        <div className="banner pointer-events">
            <video
                ref={videoRef}
                src={localUrls[url] || `https://api.psicopatici.com/public/${url}`}
                style={{
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                }}
                autoPlay
                muted
                playsInline
                onEnded={onVideoEnd}
                onError={handleVideoError}
                onStalled={handleVideoStalled}
                onWaiting={handleVideoStalled}
                controls={false}
            />
        </div>
    );
};